export default function Concept() {
  return (
    <section id="concept" className="w-full bg-[#F4D6CE] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">
          {/* Left: Image */}
          <div className="w-full lg:w-[38%] flex flex-col gap-4">
            <span className="inline-flex items-center border border-stone-400 text-stone-500 text-xs tracking-widest px-4 py-1.5 rounded-full w-fit">
              CONCEPT
            </span>
            <div className="w-full h-[480px] md:h-[560px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/a05779559d0ba0635a2d4774d27766a7.jpg"
                alt="AMYMAISON Concept"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: Text */}
          <div className="w-full lg:w-[62%] flex flex-col gap-8 lg:pt-16">
            <div>
              <p className="text-stone-400 text-2xl md:text-3xl font-light tracking-wide leading-snug">
                香りは
              </p>
              <p className="text-stone-900 text-3xl md:text-4xl lg:text-5xl font-bold italic tracking-wide leading-snug mt-1">
                「人間の本能」に訴えかける。
              </p>
            </div>

            <div className="flex flex-col gap-5 text-stone-600 text-sm md:text-base leading-loose">
              <p>
                私たちは、香りを通して空間と記憶をデザインするセントマーケティング企業です。
              </p>
              <p>
                一人ひとり、そしてお客様ごとに異なるニーズに寄り添い、
                コンセプト設計から香りの開発、空間演出までを一貫して手がけています。
              </p>
              <p>
                香りは、ただの「演出」ではなく、
                心に働きかけ、記憶を呼び起こし、感情を動かす力を持っています。
              </p>
              <p>
                私たちはその力を活かし、機能性や課題解決はもちろん、
                癒しやリラクゼーション、さらには"あの時の記憶"を呼び起こすような体験の創出まで、
                多角的に香りの価値を提供します。
              </p>
              <p>
                香りで空間の印象を変え、人の感情と記憶に残る体験を創り続けていきます。
              </p>
            </div>

            <div className="pt-2">
              <a
                href="/about"
                className="inline-block bg-stone-900 text-white text-xs tracking-widest px-8 py-3.5 rounded-full hover:bg-stone-700 transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                AMYMAISONについて
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
